import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { WrapperSuccess, PageContent, Title, Anchor, SubtitlePlaceholder, Subtitle } from './ChangePasswordPage.style';
import { TABLET_P } from '../../../constants';
import Placeholder from '../../../components/Placeholder';

const ChangePasswordSuccess = ({ copy, locale }) => (
  <WrapperSuccess>
    <PageContent>
      {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
        <Title>{copy.forgotPassword && copy.forgotPassword.changePasswordSuccess}</Title>
      ) : (
        <Placeholder h="40px" w={window.innerWidth > TABLET_P ? '500px' : '100%'} />
      )}
      {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
        <Subtitle>{copy.forgotPassword && copy.forgotPassword.changePasswordLogin}</Subtitle>
      ) : (
        <SubtitlePlaceholder>
          <Placeholder h="24px" w={window.innerWidth > TABLET_P ? '400px' : '100%'} />
        </SubtitlePlaceholder>
      )}
      {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
        <Link to={`/${locale}/salon-consultation/login`} href={`/${locale}/salon-consultation/login`}>
          <Anchor style={{ marginLeft: 0 }}>{copy.forgotPassword && copy.forgotPassword.signIn}</Anchor>
        </Link>
      ) : (
        <Placeholder h="25px" w={window.innerWidth > TABLET_P ? '250px' : '100%'} />
      )}
    </PageContent>
  </WrapperSuccess>
);

ChangePasswordSuccess.defaultProps = {
  copy: {},
};

ChangePasswordSuccess.propTypes = {
  copy: PropTypes.shape({}),
  locale: PropTypes.string.isRequired,
};

export default ChangePasswordSuccess;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/ChangePasswordPage/ChangePasswordSuccess.js